import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isVisitAllowedUser, isSplitLeadVendor,isStaffByLoginType  } from "../Utils/role"; 
const ROUTE_MENU_MAP = {
  dashboard: ["dashboard"],
  // staff: ["staff-management"],
  // role: ["staff-management"],
  // department: ["staff-management"],
    staff: ["Lead Management"],
  role: ["Lead Management"],
  department: ["Lead Management"],
  lead: ["Lead Management"],
  newlead: ["Lead Management"],
  visit: ["Lead Management"],
  pendinglead: ["Lead Management"],
  alllead: ["Lead Management"],
  LeadAssigned: ["Lead Management"],
  inventoryManagement: ["inventoryManagement", "category",  "brand", "unit", "color", "size", "wherehouse", "product", "suppliers", "purchase", "stocktransfer"],
  category: ["inventoryManagement", "category"],
  subcategory: ["inventoryManagement", "subcategory"],
  brand: ["inventoryManagement", "brand"],
  unit: ["inventoryManagement", "unit"],
  color: ["inventoryManagement", "color"],
  size: ["inventoryManagement", "size"],
  wherehouse: ["inventoryManagement", "wherehouse"],
  product: ["inventoryManagement", "product"],
  addproduct: ["inventoryManagement", "product"],
  purchase: ["inventoryManagement", "purchase"],
  stocktransfer: ["inventoryManagement", "stocktransfer"],
  suppliers: ["inventoryManagement", "suppliers"],
  module: ["inventoryManagement"],
   subscription: ["subscription"],
  mySubscriptions: ["subscription"],
  viewSubscription: ["subscription"],
    subscription: ["subscription"],
    enquiry: ["enquiry"],

  paymentHistory: ["subscription"],
};
const PermissionRoute = ({ children, permissionKey }) => {
  const { permissions, token } = useSelector((state) => state.auth);
const navigate=useNavigate();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (!permissionKey) {
    return children;
  }
  if (permissionKey === "callback" && !isSplitLeadVendor()) {
    return <Navigate to="/" replace />;
  }
  if (
    isSplitLeadVendor() &&
    ["lead", "newlead", "pendinglead", "alllead", "visit", "subscription", "mySubscriptions", "callback"].includes(permissionKey)
  ) {
    return children;
  }
// if (permissionKey === "dashboard") {
//   return children;
// }
if (permissionKey === "dashboard") {
  // ✅ Agar Staff hai, toh Dashboard mat dikhao, Staff Dashboard bhejo
  if (isStaffByLoginType()) {
    return <Navigate to="/staff-dashboard" replace />; 
  }
  return children;
}
if (permissionKey === "enquiry") {
  return children;
}
 if (permissionKey === "visit") {
    if (isVisitAllowedUser()) {
      return children; 
    } else {
      return <Navigate to="/" replace />; // Blocked
    }
  }


  const allowedMenus = permissions?.allowedMenus || [];
  if (allowedMenus.length === 0) {
    return (
      // <div style={{ padding: "50px", textAlign: "center" }}>
      //   <h2>Access Denied</h2>
      //   <p>You do not have access to this page. Please obtain permissions from the admin.</p>
      // </div>
      navigate("/", { replace: true })
    );
  }
if (
    permissionKey === "subscription" ||
    permissionKey === "mySubscriptions" ||
    permissionKey === "viewSubscription" ||
    permissionKey === "enquiry" ||
    permissionKey === "paymentHistory"
  ) {
    return children;
  }
  // if (allowedMenus.length === 0) {
  //   return children;  
  // }

  const mappedMenus = ROUTE_MENU_MAP[permissionKey] || [permissionKey];
  const hasAccess = mappedMenus.some((menuId) => allowedMenus.includes(menuId));

  if (hasAccess) {
    return children;
  }

  return (
    // <div style={{ padding: "50px", textAlign: "center" }}>
    //   <h2>Access Denied</h2>
    //   <p>Aapko is page ka access nahi hai.</p>
    // </div>
     <Navigate to="/" replace />
  );
};

export default PermissionRoute;